import { render } from "./VersionLog.vue?vue&type=template&id=10099ca4&scoped=true"
import script from "./VersionLog.vue?vue&type=script&lang=js"
export * from "./VersionLog.vue?vue&type=script&lang=js"

import "./VersionLog.vue?vue&type=style&index=0&id=10099ca4&scoped=true&lange=scss&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10099ca4"]])

export default __exports__